import React from 'react';

type Props = React.PropsWithChildren<{when: boolean}>;

const Show = (props: Props) => {
    return props.when ? <>{props.children}</> : <div/>;
}

export default Show;